export default "__VITE_ASSET__BPFVOQRH__"